<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>我的收藏</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <input
          type="text"
          placeholder="实验名称"
          v-model="queryInfo.experiment_title"
          class="s-input separate"
        >
        <input
          type="button"
          value="搜索"
          class="s-btn"
          @click="pageCallback(1)"
        >
      </div>
      <ul
        id="list"
        class="list"
        v-if="tableData.length"
      >
        <li
          v-for="(item,index) in tableData"
          :key="index"
        >
          <div class="pic-wrap">
            <template>
              <span
                class="mark mark0"
                v-if="item.experiment.auth_exp_level==1"
              >国家级</span>
              <span
                class="mark mark1"
                v-if="item.experiment.auth_exp_level==2"
              >省级</span>
              <span
                class="mark mark2"
                v-if="item.experiment.auth_exp_level==3"
              >校级</span>
            </template>
            <img
              :src="item.experiment.logo"
              :onerror="$store.state.defaultImg"
              alt=""
              @click="toPreview(item.experiment_id)"
            >
          </div>
          <div class="desc-wrap">
            <p
              class="p1"
              @click="toPreview(item.experiment_id)"
            >{{item.experiment.title}}</p>
            <p class="p2">
              <span>学院：{{item.experiment.academy?item.experiment.academy.title:'-'}}</span>
              <span>年份：{{item.created.substr(0,4)}}</span>
              <span>对应专业大类：{{item.experiment.subject?item.experiment.subject.subject_category.title:'--'}}</span>
              <span>对应专业：{{item.experiment.subject?item.experiment.subject.title:'--'}}</span>
            </p>
            <p class="text-intro">
              <span>实验简介：</span>{{item.experiment.brief}}
            </p>
            <div class="btns-wrap">
              <a
                class="btnOk btn-yellow"
                href="javascript:;"
                @click="askDel(item.id)"
              >取消收藏</a>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="noitems"
        v-else
      >没有数据</div>
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'MyExperiment',
  components: {
    Pagination
  },
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        userprofile_id: '',
        experiment_title: ''
      },
      tableData: [],
      tableDataCount: 0
    }
  },
  // 函数方法
  methods: {
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    async search() {
      this.queryInfo.userprofile_id = this.$store.state.userInfo.profile_id
      await this.$http.get('/experimentcollect/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 取消收藏
    async askDel(id) {
      const url = '/experimentcollect/' + id + '/'
      await this.$parent.showConfirm('确认取消收藏吗?', () => {
        this.$http.delete(url).then((data) => {
          this.$parent.showMsg('已取消！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('取消失败！')
        })
      })
    },
    toPreview(id) {
      this.$router.push('/www/experiment?id=' + id)
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped lang="less">
.list li {
  overflow: hidden;
  margin-bottom: 20px;
  padding: 20px 0;
  border-bottom: 2px solid #f1f5f5;
  .pic-wrap {
    width: 240px;
    height: 160px;
    float: left;
    position: relative;
    cursor: pointer;
    .mark {
      position: absolute;
      left: 0;
      top: 0;
      height: 26px;
      line-height: 26px;
      padding: 0 10px;
      font-size: 12px;
      color: #fff;
      border-bottom-right-radius: 5px;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .mark0 {
      background: #eb6736;
    }
    .mark1 {
      background: #009999;
    }
    .mark2 {
      background: #ff9000;
    }
  }
  .desc-wrap {
    padding-left: 260px;
    font-size: 14px;
    color: #666;
    .p1 {
      font-size: 18px;
      color: #000;
      cursor: pointer;
    }
    .p2 {
      color: #4a5d76;
      padding: 5px 0;
      span {
        color: #666;
        margin-right: 30px;
        line-height: 26px;
      }
    }
    .text-intro {
      height: 52px;
      overflow-y: auto;
      > span {
        color: #000;
      }
    }
    .btns-wrap {
      margin-top: 10px;
      overflow: hidden;
      .btnOk {
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        border-radius: 5px;
        color: #fff;
        float: left;
        margin-right: 10px;
      }
      .btn-yellow {
        background: #f7b500;
      }
    }
  }
}
</style>
